import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setGoogleUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    console.log("[AuthCallback] triggered");

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      console.log("[AuthCallback] no session_id in hash, redirecting to login");
      navigate("/admin/login", { replace: true });
      return;
    }

    const sessionId = match[1];
    console.log("[AuthCallback] session_id received:", sessionId.substring(0, 10) + "...");

    (async () => {
      try {
        console.log("[AuthCallback] calling /api/auth/google/session...");
        const { data } = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
        });
        console.log("[AuthCallback] API response:", data.email, data.role);

        // Store tokens
        if (data.access_token) sessionStorage.setItem("access_token", data.access_token);
        if (data.refresh_token) sessionStorage.setItem("refresh_token", data.refresh_token);
        console.log("[AuthCallback] tokens stored in sessionStorage");

        // Update AuthContext state BEFORE navigating
        setGoogleUser(data);
        console.log("[AuthCallback] user set in AuthContext");

        // Force redirect — use window.location for maximum reliability
        console.log("[AuthCallback] redirecting to /admin");
        window.location.replace(window.location.origin + "/admin");
      } catch (e) {
        const msg = e?.response?.data?.detail || e?.message || "Google sign-in failed";
        console.error("[AuthCallback] error:", msg);
        navigate("/admin/login", { replace: true, state: { error: msg } });
      }
    })();
  }, [navigate, setGoogleUser]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[#D4AF37] mx-auto animate-spin mb-4" />
        <p className="text-white/40 text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
